// extracted by mini-css-extract-plugin
export default {"container":"PageNotFound_container__+mfUz","hero-text":"PageNotFound_hero-text__ija3f"};